import LoadingSkeletonElement from '../../loading/LoadingSkeletonElementV2';
import LoadingSkeletonWrapper from '../../loading/LoadingSkeletonWrapper';
import { Tab, Tabs } from 'foundations-components/transitional/components/Tabs';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ABTabsPlaceholder = () => /*#__PURE__*/_jsxs(Tabs, {
  Wrapper: LoadingSkeletonWrapper,
  bordered: false,
  children: [/*#__PURE__*/_jsx(Tab, {
    padding: "0",
    title: /*#__PURE__*/_jsx(LoadingSkeletonElement, {
      marginBlock: "0",
      blockSize: "36px",
      inlineSize: "120px"
    })
  }), /*#__PURE__*/_jsx(Tab, {
    padding: "0",
    title: /*#__PURE__*/_jsx(LoadingSkeletonElement, {
      marginBlock: "0",
      blockSize: "36px",
      inlineSize: "120px"
    })
  }), /*#__PURE__*/_jsx(Tab, {
    padding: "0",
    title: /*#__PURE__*/_jsx(LoadingSkeletonElement, {
      marginBlock: "0",
      blockSize: "36px",
      inlineSize: "120px"
    })
  }), /*#__PURE__*/_jsx(Tab, {
    padding: "0",
    title: /*#__PURE__*/_jsx(LoadingSkeletonElement, {
      marginBlock: "0",
      blockSize: "36px",
      inlineSize: "120px"
    })
  })]
});